import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Star } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
import { formatMoney } from '../../utils/formatMoney';
import {
  formatSoiDaoCountdown,
  tickRemainingTime,
} from '../../utils/soiDaoUtils';

export function SoiDaoRoomCard({ room }) {
  const [displayTime, setDisplayTime] = useState(room.remainingTime);

  useEffect(() => {
    setDisplayTime(room.remainingTime);
  }, [room.remainingTime]);

  useEffect(() => {
    if (!displayTime || displayTime.isExpired) return undefined;
    const timer = setInterval(() => {
      setDisplayTime((prev) => tickRemainingTime(prev));
    }, 1000);
    return () => clearInterval(timer);
  }, [displayTime]);

  const prizes = Array.isArray(room.prizes)
    ? room.prizes.map((prize) =>
        typeof prize === 'object'
          ? prize
          : {
              amount: Number(prize) || 0,
              status: 'locked',
            },
      )
    : [];

  return (
    <Link to={`/soi-dao/${room.id}`} className="group block">
      <Card className="h-full border-2 border-gray-200 transition-all hover:border-brand-red hover:shadow-lg">
        <CardContent className="space-y-4 p-5">
          <div className="flex items-start justify-between gap-2">
            <div>
              <h3 className="flex items-center gap-2 text-lg font-bold text-brand-red group-hover:underline">
                <Star className="h-5 w-5 fill-brand-gold text-brand-gold" />
                {room.name}
              </h3>
              <p className="text-xs text-gray-500">
                ราคาต่อดาว {formatMoney(room.price)}
              </p>
            </div>
            <ArrowRight className="h-5 w-5 shrink-0 text-gray-300 transition-colors group-hover:text-brand-red" />
          </div>

          <div className="flex items-center justify-between rounded-xl bg-red-50 px-3 py-2">
            <span className="flex items-center gap-1 text-xs text-gray-600">
              <Clock className="h-3.5 w-3.5" />
              ปิดรอบใน
            </span>
            <span className="font-mono text-sm font-bold text-brand-red">
              {formatSoiDaoCountdown(displayTime)}
            </span>
          </div>

          <div className="grid grid-cols-5 gap-1">
            {prizes.slice(0, 5).map((prize, index) => (
              <div
                key={`${room.id}-prize-${index}`}
                className={`rounded-lg border px-0.5 py-2 text-center ${
                  prize.status === 'locked'
                    ? 'border-gray-200 bg-gray-50'
                    : 'border-brand-gold/40 bg-brand-gold-light/20'
                }`}
              >
                <p className="text-[9px] text-gray-500">รางวัล #{index + 1}</p>
                <p className="text-xs font-bold text-brand-gold">
                  {formatMoney(prize.amount)}
                </p>
              </div>
            ))}
          </div>

          <p className="text-center text-xs text-gray-400">
            รอบ #{room.round?.roundNumber || '-'} · เปิดแล้ว {room.entryCount ?? 0}{' '}
            ดาว
          </p>
        </CardContent>
      </Card>
    </Link>
  );
}
